import clsx from 'clsx';
import React, { Fragment, useEffect, useState } from 'react';
import { Breadcrumb, Header } from 'semantic-ui-react';
import { HeaderMenuBreadcrumb } from '../../interfaces/HeaderMenuBreadcrumb';
import './HeaderMenu.less';

export interface Props {
  title?: string;
  middleContent?: React.ReactNode;
  bottomContent?: React.ReactNode;
  breadcrumbs: HeaderMenuBreadcrumb[];
  ctaContent?: React.ReactNode;
  compact?: boolean;
  topRightContent?: React.ReactNode;
  backgroundColor?: string;
  configHeader?: boolean;
}

export const HeaderMenu = ({
  middleContent,
  bottomContent,
  breadcrumbs,
  ctaContent,
  title,
  compact,
  topRightContent,
  configHeader,
}: Props) => {
  const [configHeaderClassName, setConfigHeaderClassName] = useState('');
  const headerRef = React.createRef<HTMLDivElement>();

  const isSolo =
    breadcrumbs &&
    !bottomContent &&
    !middleContent &&
    !ctaContent &&
    !title &&
    !topRightContent;

  useEffect(() => {
    if (!configHeader) return;

    //Get the parent elements of the Header div to find if it is OS-Environment/Standalone.
    let element = headerRef.current?.parentElement ?? null;
    const className = 'config';
    while (element) {
      if (element?.id === 'root' || element?.id === 'docs-root') {
        setConfigHeaderClassName(` ${className} inverted`);
        break;
      } else if (element.className === 'micro-module') {
        setConfigHeaderClassName(` ${className} transparent`);
        break;
      }
      element = element.parentElement;
    }
  }, [configHeader, headerRef]);

  return (
    <div ref={headerRef} className={`p-os-header-menu${configHeaderClassName}`}>
      <div className="title-section">
        <Breadcrumb size="mini">
          {breadcrumbs.map((b, i) => (
            <Fragment key={`${b.name}_${i}`}>
              <Breadcrumb.Divider />
              <Breadcrumb.Section link key={b.name} onClick={b.onClick}>
                {b.name}
              </Breadcrumb.Section>
            </Fragment>
          ))}
        </Breadcrumb>

        {title && (
          <Header as="h1" textAlign="center">
            {title}
          </Header>
        )}

        {topRightContent && (
          <div className="top-right-content">{topRightContent}</div>
        )}
      </div>

      {middleContent && (
        <div className="p-os-header-menu__middle">
          <div>{middleContent}</div>
        </div>
      )}

      <div
        className={clsx({
          'p-os-header-menu__bottom': !isSolo,
          'p-os-header-menu__bottom--with-middle': middleContent,
        })}
      >
        <div
          className={clsx('ctaContent', {
            compact: compact,
          })}
        >
          {/* buffer empty div if bottomContent empty */}
          {!bottomContent && <div></div>}
          {bottomContent}
          {ctaContent && <div className="rightSide">{ctaContent}</div>}
        </div>
      </div>
    </div>
  );
};
